import classes from './styles.module.css';
import TextLink from '../TextLink';

const Footer = () => {
  return (
    <div className={classes.Footer}>
      <div className={classes.Copyright}>
        Copyright 2023 Marubeni Forest LinX Co., Ltd. All Rights Reserved.
      </div>
      <div className={classes.PrivacyPolicy}>
        <TextLink variants={['small']} to={'/privacy-policy'}>
          プライバシーポリシー
        </TextLink>
      </div>
      <div className={classes.Partition}> | </div>
      <div className={classes.TermsOfService}>
        <TextLink variants={['small']} to={'/terms-of-service'}>
          利用規約
        </TextLink>
      </div>
    </div>
  );
};

export default Footer;
